import React from 'react';
import { StatusIconProps } from './utils';

function Guidance({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9652 14C14.1732 13.5288 14.4736 13.0873 14.7683 12.6543L14.7705 12.651C14.8152 12.5854 14.8599 12.5196 14.904 12.4543C15.2803 11.8962 15.5 11.2238 15.5 10.5C15.5 8.567 13.933 7 12 7C10.067 7 8.5 8.567 8.5 10.5C8.5 11.2238 8.71969 11.8962 9.09603 12.4543C9.1404 12.5201 9.1857 12.5867 9.2307 12.6528L9.23163 12.6542C9.52633 13.0872 9.82682 13.5288 10.0348 14H13.9652Z"
        fill="white"
      />
      <path
        d="M10.3 15L10.41 16.0995C10.4611 16.6107 10.8912 17 11.405 17H12.595C13.1088 17 13.5389 16.6107 13.59 16.0995L13.7 15H10.3Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM14.7683 12.6543C14.4736 13.0873 14.1732 13.5288 13.9652 14H10.0348C9.82682 13.5288 9.52633 13.0872 9.23163 12.6542L9.2307 12.6528C9.1857 12.5867 9.1404 12.5201 9.09603 12.4543C8.71969 11.8962 8.5 11.2238 8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5C15.5 11.2238 15.2803 11.8962 14.904 12.4543C14.8599 12.5196 14.8152 12.5854 14.7705 12.651L14.7683 12.6543ZM10.41 16.0995L10.3 15H13.7L13.59 16.0995C13.5389 16.6107 13.1088 17 12.595 17H11.405C10.8912 17 10.4611 16.6107 10.41 16.0995Z"
        fill="#53B7B0"
      />
    </svg>
  );
}
Guidance.propTypes = StatusIconProps;

export default Guidance;
